import { css } from '@emotion/react'
import { ExternalStyles } from 'bold-ui'
import { useState } from 'react'

import pausedImg from '../../../images/novidades/icons/pause.webp'

interface NewsGifProps {
  src: string
  alt: string
  pausedSrc: string
  customStyles?: ExternalStyles
}

export const NewsGif = (props: NewsGifProps) => {
  const { alt, src, pausedSrc, customStyles } = props
  const [isPlaying, setIsPlaying] = useState(false)
  const classes = styles()

  const togglePlaying = () => {
    setIsPlaying(!isPlaying)
  }

  const renderAnimation = () =>
    src.endsWith('.webm') ? (
      <video src={src} css={classes.imageGif} autoPlay loop muted playsInline />
    ) : (
      <img src={src} alt={alt} css={classes.imageGif} />
    )

  return (
    <div css={[classes.container, customStyles]} onClick={togglePlaying}>
      {isPlaying ? renderAnimation() : <img src={pausedSrc} alt={alt} css={classes.imageGif} />}
      {!isPlaying && <img src={pausedImg} alt='Imagem de pause' css={classes.pausedImg} />}
    </div>
  )
}

const styles = () => ({
  container: css`
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 100%;
    max-height: 430px;
    position: relative;
    cursor: pointer;
  `,
  imageGif: css`
    max-width: 100%;
    max-height: 430px;
    image-rendering: -webkit-optimize-contrast;
    border: 1px solid;
  `,
  pausedImg: css`
    position: absolute;
    left: 45%;
    top: 42%;
    width: 80px;
    height: 80px;
  `,
})
